{
    "navigation": [
        {
            "id": "nav-sales-dashboard",
            "label": "Sales Dashboard",
            "keywords": ["sales", "dashboard", "home", "crm"],
            "path": "/sales/dashboard",
            "section": "Sales",
            "breadcrumb": "Sales"
        },
        {
            "id": "nav-marketing-dashboard",
            "label": "Marketing Dashboard",
            "keywords": ["marketing", "dashboard", "email marketing"],
            "path": "/marketing/dashboard",
            "section": "Marketing",
            "breadcrumb": "Marketing"
        },
        {
            "id": "nav-engagement-dashboard",
            "label": "Engagement Dashboard",
            "keywords": ["engagement", "inbox", "dashboard", "chat"],
            "path": "/inbox/dashboard",
            "section": "Engagement",
            "breadcrumb": "Engagement"
        },
        {
            "id": "nav-companies",
            "label": "Companies",
            "keywords": ["companies", "accounts", "organizations"],
            "path": "/companies",
            "section": "Entities",
            "breadcrumb": "Companies"
        },
        {
            "id": "nav-people",
            "label": "People",
            "keywords": ["people", "contacts", "persons"],
            "path": "/people",
            "section": "Entities",
            "breadcrumb": "People"
        },
        {
            "id": "nav-leads",
            "label": "Leads",
            "keywords": ["leads", "opportunities", "deals"],
            "path": "/leads",
            "section": "Entities",
            "breadcrumb": "Leads"
        },
        {
            "id": "nav-ai-home",
            "label": "Nutshell AI",
            "keywords": ["ai", "artificial intelligence", "assistant", "nutshell ai"],
            "path": "/ai/home",
            "section": "AI",
            "breadcrumb": "AI"
        },
        {
            "id": "nav-sales-scheduler",
            "label": "Scheduler",
            "keywords": ["scheduler", "booking", "meetings", "calendar scheduling"],
            "path": "/sales/scheduler",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach"
        },
        {
            "id": "nav-sales-calls",
            "label": "Calls",
            "keywords": ["calls", "phone", "dialer", "click to call"],
            "path": "/sales/calls",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach"
        },
        {
            "id": "nav-sales-meetings-zoom",
            "label": "Zoom Meetings",
            "keywords": ["zoom", "meetings", "video", "notetaker"],
            "path": "/sales/meetings/zoom",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach > Meetings"
        },
        {
            "id": "nav-sales-meetings-meet",
            "label": "Google Meet",
            "keywords": ["google meet", "meetings", "video", "notetaker"],
            "path": "/sales/meetings/meet",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach > Meetings"
        },
        {
            "id": "nav-sales-meetings-teams",
            "label": "Microsoft Teams",
            "keywords": ["teams", "microsoft teams", "meetings", "video", "notetaker"],
            "path": "/sales/meetings/teams",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach > Meetings"
        },
        {
            "id": "nav-sales-prospectoriq",
            "label": "ProspectorIQ",
            "keywords": ["prospector", "prospecting", "iq", "find leads", "lead generation"],
            "path": "/sales/prospectoriq",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach"
        },
        {
            "id": "nav-sales-email-templates",
            "label": "Email Templates",
            "keywords": ["email templates", "templates", "email", "sales email"],
            "path": "/sales/email/templates",
            "section": "Sales",
            "breadcrumb": "Sales > Outreach"
        },
        {
            "id": "nav-sales-quote-overview",
            "label": "Quotes",
            "keywords": ["quotes", "proposals", "quote overview", "pricing"],
            "path": "/sales/quote-overview",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue"
        },
        {
            "id": "nav-sales-quote-template",
            "label": "Quote Template",
            "keywords": ["quote template", "quote design"],
            "path": "/sales/quote-template",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue > Quotes"
        },
        {
            "id": "nav-sales-invoice-overview",
            "label": "Invoices",
            "keywords": ["invoices", "billing", "payments", "invoice overview"],
            "path": "/sales/invoice-overview",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue"
        },
        {
            "id": "nav-sales-invoice-template",
            "label": "Invoice Template",
            "keywords": ["invoice template", "invoice design"],
            "path": "/sales/invoice-template",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue > Invoices"
        },
        {
            "id": "nav-sales-products",
            "label": "Products",
            "keywords": ["products", "catalog", "product list"],
            "path": "/sales/product",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue"
        },
        {
            "id": "nav-sales-product-categories",
            "label": "Product Categories",
            "keywords": ["product categories", "categories"],
            "path": "/sales/product/categories",
            "section": "Sales",
            "breadcrumb": "Sales > Revenue > Products"
        },
        {
            "id": "nav-sales-pipelines",
            "label": "Pipelines",
            "keywords": ["pipelines", "stages", "sales process", "workflow", "automation"],
            "path": "/sales/pipelines",
            "section": "Sales",
            "breadcrumb": "Sales > Strategy"
        },
        {
            "id": "nav-sales-lead-outcomes",
            "label": "Lead Outcomes",
            "keywords": ["lead outcomes", "win", "loss", "outcomes", "close reasons"],
            "path": "/sales/lead-outcomes",
            "section": "Sales",
            "breadcrumb": "Sales > Strategy > Pipelines"
        },
        {
            "id": "nav-sales-sales-quotas",
            "label": "Sales Quotas",
            "keywords": ["sales quotas", "quotas", "targets", "goals"],
            "path": "/sales/sales-quotas",
            "section": "Sales",
            "breadcrumb": "Sales > Strategy"
        },
        {
            "id": "nav-sales-activity-quotas",
            "label": "Activity Quotas",
            "keywords": ["activity quotas", "activity targets", "quotas"],
            "path": "/sales/activity-quotas",
            "section": "Sales",
            "breadcrumb": "Sales > Strategy"
        },
        {
            "id": "nav-marketing-broadcasts",
            "label": "Email Broadcasts",
            "keywords": ["broadcasts", "email blasts", "mass email", "email campaigns"],
            "path": "/marketing/email/broadcasts",
            "section": "Marketing",
            "breadcrumb": "Marketing > Email"
        },
        {
            "id": "nav-marketing-newsletters",
            "label": "Newsletters",
            "keywords": ["newsletters", "email newsletter"],
            "path": "/marketing/email/newsletters",
            "section": "Marketing",
            "breadcrumb": "Marketing > Email"
        },
        {
            "id": "nav-marketing-drip-sequences",
            "label": "Drip Sequences",
            "keywords": ["drip", "sequences", "email drip", "automation", "nurture"],
            "path": "/marketing/email/drip-sequences",
            "section": "Marketing",
            "breadcrumb": "Marketing > Email"
        },
        {
            "id": "nav-marketing-email-templates",
            "label": "Marketing Email Templates",
            "keywords": ["marketing templates", "email templates"],
            "path": "/marketing/email/templates",
            "section": "Marketing",
            "breadcrumb": "Marketing > Email"
        },
        {
            "id": "nav-marketing-preference-center",
            "label": "Preference Center",
            "keywords": ["preference center", "email preferences", "unsubscribe"],
            "path": "/marketing/email/preference-center",
            "section": "Marketing",
            "breadcrumb": "Marketing > Email"
        },
        {
            "id": "nav-marketing-sms-broadcasts",
            "label": "SMS Broadcasts",
            "keywords": ["sms", "text message", "sms broadcasts"],
            "path": "/marketing/sms/broadcasts",
            "section": "Marketing",
            "breadcrumb": "Marketing > SMS"
        },
        {
            "id": "nav-marketing-sms-drip",
            "label": "SMS Drip Sequences",
            "keywords": ["sms drip", "text drip", "sms sequences"],
            "path": "/marketing/sms/drip-sequences",
            "section": "Marketing",
            "breadcrumb": "Marketing > SMS"
        },
        {
            "id": "nav-marketing-analytics",
            "label": "Website Analytics",
            "keywords": ["analytics", "website analytics", "traffic", "visitors"],
            "path": "/marketing/analytics",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-visitors",
            "label": "VisitorIQ",
            "keywords": ["visitor iq", "visitors", "website visitors", "visitor tracking"],
            "path": "/marketing/visitors",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-forms",
            "label": "Nutshell Forms",
            "keywords": ["forms", "web forms", "nutshell forms", "form builder"],
            "path": "/marketing/forms",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-connected-forms",
            "label": "Connected Forms",
            "keywords": ["connected forms", "external forms", "form integrations"],
            "path": "/marketing/connected-forms",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-competitors",
            "label": "CompetitorSpy",
            "keywords": ["competitor spy", "competitors", "competitor tracking"],
            "path": "/marketing/competitors",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-landing-pages",
            "label": "Landing Pages",
            "keywords": ["landing pages", "web pages", "page builder"],
            "path": "/marketing/landing-pages",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-automations",
            "label": "Marketing Automations",
            "keywords": ["automations", "marketing automations", "workflows"],
            "path": "/marketing/automations",
            "section": "Marketing",
            "breadcrumb": "Marketing > Website"
        },
        {
            "id": "nav-marketing-seo-scan",
            "label": "SEO Scan",
            "keywords": ["seo", "seo scan", "search engine", "google ranking"],
            "path": "/marketing/seo-scan",
            "section": "Marketing",
            "breadcrumb": "Marketing > Lead Generation"
        },
        {
            "id": "nav-marketing-audiences",
            "label": "Audiences",
            "keywords": ["audiences", "segments", "lists", "targeting"],
            "path": "/marketing/audiences",
            "section": "Marketing",
            "breadcrumb": "Marketing"
        },
        {
            "id": "nav-marketing-domains",
            "label": "Marketing Domains",
            "keywords": ["domains", "marketing domains", "email domains"],
            "path": "/marketing/domains",
            "section": "Marketing",
            "breadcrumb": "Marketing > Setup"
        },
        {
            "id": "nav-marketing-sender-address",
            "label": "Sender Addresses",
            "keywords": ["sender address", "from address", "email sender"],
            "path": "/marketing/sender-address",
            "section": "Marketing",
            "breadcrumb": "Marketing > Setup"
        },
        {
            "id": "nav-inbox-all",
            "label": "All Channels",
            "keywords": ["all channels", "inbox", "messages", "conversations"],
            "path": "/inbox/all/open",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-chat",
            "label": "Agent Threads",
            "keywords": ["chat", "agent threads", "live chat", "chatbot"],
            "path": "/inbox/chat/open",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-sms",
            "label": "SMS Inbox",
            "keywords": ["sms inbox", "text messages", "sms"],
            "path": "/inbox/sms/open",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-messenger",
            "label": "Messenger",
            "keywords": ["messenger", "facebook messenger", "facebook"],
            "path": "/inbox/messenger/unassigned",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-instagram",
            "label": "Instagram",
            "keywords": ["instagram", "instagram dms"],
            "path": "/inbox/instagram/unassigned",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-whatsapp",
            "label": "WhatsApp",
            "keywords": ["whatsapp", "whatsapp messages"],
            "path": "/inbox/whatsapp/open",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-shared-email",
            "label": "Shared Email",
            "keywords": ["email inbox", "shared email", "shared inbox", "email"],
            "path": "/inbox/email/open",
            "section": "Engagement",
            "breadcrumb": "Engagement > Inbox"
        },
        {
            "id": "nav-inbox-leads",
            "label": "Engagement Leads",
            "keywords": ["engagement leads", "inbox leads"],
            "path": "/inbox/leads",
            "section": "Engagement",
            "breadcrumb": "Engagement"
        },
        {
            "id": "nav-inbox-chatbot-threads",
            "label": "Chatbot Threads",
            "keywords": ["chatbot", "bot threads", "chatbot threads"],
            "path": "/inbox/chatbot-threads",
            "section": "Engagement",
            "breadcrumb": "Engagement"
        },
        {
            "id": "nav-inbox-settings-chat",
            "label": "Chat Settings",
            "keywords": ["chat settings", "chatbot settings", "widget settings"],
            "path": "/inbox/settings/chat",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin > Setup"
        },
        {
            "id": "nav-inbox-settings-sms",
            "label": "SMS Settings",
            "keywords": ["sms settings", "text message settings"],
            "path": "/inbox/settings/sms",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin > Setup"
        },
        {
            "id": "nav-inbox-settings-facebook",
            "label": "Facebook Settings",
            "keywords": ["facebook settings", "messenger settings"],
            "path": "/inbox/settings/facebook",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin > Setup"
        },
        {
            "id": "nav-inbox-settings-whatsapp",
            "label": "WhatsApp Settings",
            "keywords": ["whatsapp settings"],
            "path": "/inbox/settings/whatsapp",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin > Setup"
        },
        {
            "id": "nav-inbox-settings-email",
            "label": "Shared Email Settings",
            "keywords": ["shared email settings", "email forwarding", "shared inbox settings"],
            "path": "/inbox/settings/email",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin > Setup"
        },
        {
            "id": "nav-inbox-agents",
            "label": "Agents",
            "keywords": ["agents", "chatbot agents", "ai agents", "bot agents"],
            "path": "/inbox/settings/agents",
            "section": "Engagement",
            "breadcrumb": "Engagement > Admin"
        },
        {
            "id": "nav-reports-overview",
            "label": "Reports Overview",
            "keywords": ["reports", "overview", "report generator", "ai reports"],
            "path": "/reports/overview",
            "section": "Reports",
            "breadcrumb": "Reports"
        },
        {
            "id": "nav-reports-sales",
            "label": "Sales Report",
            "keywords": ["sales report", "revenue report", "won deals"],
            "path": "/reports/sales/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-losses",
            "label": "Losses Report",
            "keywords": ["losses report", "lost deals", "lost leads"],
            "path": "/reports/losses/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-new-leads",
            "label": "New Leads Report",
            "keywords": ["new leads report", "lead creation", "new opportunities"],
            "path": "/reports/newleads/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-attribution",
            "label": "Attribution Report",
            "keywords": ["attribution", "source attribution", "marketing attribution"],
            "path": "/reports/attribution/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-forecast",
            "label": "Forecast Report",
            "keywords": ["forecast", "sales forecast", "pipeline forecast", "predictions"],
            "path": "/reports/forecast/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-custom",
            "label": "Custom Report",
            "keywords": ["custom report", "report builder"],
            "path": "/reports/custom/details",
            "section": "Reports",
            "breadcrumb": "Reports > Leads"
        },
        {
            "id": "nav-reports-activity",
            "label": "Activity Report",
            "keywords": ["activity report", "effort report", "activity tracking"],
            "path": "/reports/activity",
            "section": "Reports",
            "breadcrumb": "Reports > Effort"
        },
        {
            "id": "nav-reports-email",
            "label": "Email Report",
            "keywords": ["email report", "email analytics", "email tracking"],
            "path": "/reports/email",
            "section": "Reports",
            "breadcrumb": "Reports > Effort"
        },
        {
            "id": "nav-reports-tasks",
            "label": "Tasks Report",
            "keywords": ["tasks report", "task analytics"],
            "path": "/reports/tasks",
            "section": "Reports",
            "breadcrumb": "Reports > Effort"
        },
        {
            "id": "nav-reports-snapshots",
            "label": "Snapshots Report",
            "keywords": ["snapshots", "pipeline snapshots", "historical"],
            "path": "/reports/snapshots",
            "section": "Reports",
            "breadcrumb": "Reports > Other"
        },
        {
            "id": "nav-reports-funnel",
            "label": "Funnel Report",
            "keywords": ["funnel", "conversion funnel", "pipeline funnel"],
            "path": "/reports/funnel",
            "section": "Reports",
            "breadcrumb": "Reports > Other"
        },
        {
            "id": "nav-reports-engagement",
            "label": "Engagement Report",
            "keywords": ["engagement report", "inbox report"],
            "path": "/reports/engagement",
            "section": "Reports",
            "breadcrumb": "Reports > Other"
        },
        {
            "id": "nav-reports-chatbot",
            "label": "Chatbot Report",
            "keywords": ["chatbot", "chatbot report", "bot report", "chat report"],
            "path": "/reports/chatbot",
            "section": "Reports",
            "breadcrumb": "Reports > Other"
        },
        {
            "id": "nav-my-profile",
            "label": "Profile",
            "keywords": ["profile", "my profile", "account settings", "personal settings"],
            "path": "/my-account/settings",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-phone",
            "label": "Phone Settings",
            "keywords": ["phone", "phone settings", "calling", "phone number"],
            "path": "/my-account/phone",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-calendar",
            "label": "Calendar Settings",
            "keywords": ["calendar", "calendar sync", "calendar settings"],
            "path": "/my-account/calendar",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-notifications",
            "label": "Notification Settings",
            "keywords": ["notifications", "alerts", "notification settings"],
            "path": "/my-account/notifications",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-email-digests",
            "label": "Email Digests",
            "keywords": ["email digests", "daily digest", "email summary"],
            "path": "/my-account/email-digests",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-tasks",
            "label": "Task Settings",
            "keywords": ["tasks", "task settings", "task defaults"],
            "path": "/my-account/tasks",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-email-sending",
            "label": "Email Sending Settings",
            "keywords": ["email sending", "email send", "smtp", "outbound email"],
            "path": "/my-account/email-sending",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-my-email-syncing",
            "label": "Email Syncing",
            "keywords": ["email sync", "email syncing", "imap", "email connection"],
            "path": "/my-account/email-syncing",
            "section": "Settings",
            "breadcrumb": "Settings > Your Settings"
        },
        {
            "id": "nav-setup-general",
            "label": "General Settings",
            "keywords": ["general", "company settings", "organization settings"],
            "path": "/setup/index",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-ai-features",
            "label": "AI Features",
            "keywords": [
                "ai features",
                "ai settings",
                "artificial intelligence",
                "ai configuration"
            ],
            "path": "/setup/ai-features",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-security",
            "label": "Security Settings",
            "keywords": ["security", "password policy", "two factor", "2fa", "mfa"],
            "path": "/setup/security",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-billing",
            "label": "Billing",
            "keywords": ["billing", "subscription", "plan", "payment", "upgrade"],
            "path": "/setup/billing",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-users",
            "label": "Users & Teams",
            "keywords": ["users", "teams", "user management", "team management", "invite"],
            "path": "/setup/user",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-audit-log",
            "label": "Audit Log",
            "keywords": ["audit log", "activity log", "history", "changes"],
            "path": "/setup/audit-log",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-email-security",
            "label": "Email Security",
            "keywords": ["email security", "dkim", "spf", "email authentication"],
            "path": "/setup/email-security",
            "section": "Settings",
            "breadcrumb": "Settings > Administration"
        },
        {
            "id": "nav-setup-import",
            "label": "Import Data",
            "keywords": ["import", "data import", "csv import", "upload"],
            "path": "/setup/import",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-export",
            "label": "Export Data",
            "keywords": ["export", "data export", "download", "csv export"],
            "path": "/setup/export",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-integrations",
            "label": "Integrations",
            "keywords": ["integrations", "apps", "connect", "third party", "zapier"],
            "path": "/setup/integration",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-people-iq",
            "label": "PeopleIQ",
            "keywords": ["people iq", "enrichment", "data enrichment"],
            "path": "/setup/people-iq",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-sql-access",
            "label": "SQL Access",
            "keywords": ["sql", "sql access", "database", "query"],
            "path": "/setup/sql-access",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-trash",
            "label": "Trash",
            "keywords": ["trash", "deleted", "recycle bin", "restore"],
            "path": "/trash",
            "section": "Settings",
            "breadcrumb": "Settings > Data"
        },
        {
            "id": "nav-setup-activity-types",
            "label": "Activity Types",
            "keywords": ["activity types", "call", "meeting", "activity"],
            "path": "/setup/activity-type",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-sources",
            "label": "Channels & Sources",
            "keywords": ["channels", "sources", "lead source", "attribution source"],
            "path": "/setup/source",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-company-types",
            "label": "Company Types",
            "keywords": ["company types", "account types"],
            "path": "/setup/company-type",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-competitors",
            "label": "Competitors",
            "keywords": ["competitors", "competition"],
            "path": "/setup/competitor",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-custom-fields",
            "label": "Custom Fields",
            "keywords": ["custom fields", "fields", "custom data", "metadata"],
            "path": "/setup/custom-field",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-industries",
            "label": "Industries",
            "keywords": ["industries", "industry types"],
            "path": "/setup/industry",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-markets",
            "label": "Markets",
            "keywords": ["markets", "market segments"],
            "path": "/setup/market",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-products",
            "label": "Products (Settings)",
            "keywords": ["products setup", "product settings"],
            "path": "/setup/product",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-tags",
            "label": "Tags",
            "keywords": ["tags", "labels"],
            "path": "/setup/tag",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-territories",
            "label": "Territories",
            "keywords": ["territories", "regions", "geographic"],
            "path": "/setup/territory",
            "section": "Settings",
            "breadcrumb": "Settings > Organization"
        },
        {
            "id": "nav-setup-api-keys",
            "label": "API Keys",
            "keywords": ["api keys", "api", "developer", "rest api"],
            "path": "/setup/api-key",
            "section": "Settings",
            "breadcrumb": "Settings > Connections"
        },
        {
            "id": "nav-setup-mobile",
            "label": "Mobile Devices",
            "keywords": ["mobile", "mobile devices", "phone app", "ios", "android"],
            "path": "/setup/mobile",
            "section": "Settings",
            "breadcrumb": "Settings > Connections"
        },
        {
            "id": "nav-setup-domains",
            "label": "Domains",
            "keywords": ["domains", "website domains", "domain settings"],
            "path": "/setup/domains",
            "section": "Settings",
            "breadcrumb": "Settings > Website"
        },
        {
            "id": "nav-setup-tracking-snippet",
            "label": "Tracking Snippet",
            "keywords": ["tracking snippet", "tracking code", "website tracking", "analytics code"],
            "path": "/setup/tracking-snippet",
            "section": "Settings",
            "breadcrumb": "Settings > Website"
        }
    ],
    "actions": [
        {
            "id": "action-create-company",
            "label": "Create new company",
            "keywords": [
                "create company",
                "new company",
                "add company",
                "new account",
                "add account"
            ],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/accounts"
        },
        {
            "id": "action-create-person",
            "label": "Create new person",
            "keywords": ["create person", "new person", "add person", "new contact", "add contact"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/contacts"
        },
        {
            "id": "action-create-lead",
            "label": "Create new lead",
            "keywords": ["create lead", "new lead", "add lead", "new deal", "new opportunity"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/leads"
        },
        {
            "id": "action-log-activity",
            "label": "Log an activity",
            "keywords": [
                "log activity",
                "new activity",
                "add activity",
                "log call",
                "log meeting",
                "phone call"
            ],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/activities"
        },
        {
            "id": "action-create-task",
            "label": "Create a task",
            "keywords": ["create task", "new task", "add task", "reminder", "todo"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/tasks"
        },
        {
            "id": "action-create-form",
            "label": "Create a form",
            "keywords": ["create form", "new form", "web form", "add form"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/forms"
        },
        {
            "id": "action-create-quote",
            "label": "Create a quote",
            "keywords": ["create quote", "new quote", "add quote", "proposal"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/quotes"
        },
        {
            "id": "action-create-invoice",
            "label": "Create an invoice",
            "keywords": ["create invoice", "new invoice", "add invoice", "bill"],
            "section": "Create",
            "actionType": "hash",
            "actionValue": "#/create/invoices"
        },

        {
            "id": "action-import-data",
            "label": "Import data",
            "keywords": ["import", "csv import", "upload data", "bulk import"],
            "section": "Data",
            "actionType": "navigate",
            "actionValue": "/setup/import"
        },
        {
            "id": "action-export-data",
            "label": "Export data",
            "keywords": ["export", "csv export", "download data"],
            "section": "Data",
            "actionType": "navigate",
            "actionValue": "/setup/export"
        },
        {
            "id": "action-open-ai",
            "label": "Open Nutshell AI",
            "keywords": ["ai", "nutshell ai", "assistant", "ai home"],
            "section": "AI",
            "actionType": "navigate",
            "actionValue": "/ai/home"
        },

        {
            "id": "action-create-newsletter",
            "label": "Create newsletter",
            "keywords": ["create newsletter", "new newsletter", "email newsletter"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/email/newsletters"
        },
        {
            "id": "action-create-sms-broadcast",
            "label": "Create SMS broadcast",
            "keywords": ["create sms broadcast", "new sms", "text broadcast", "sms campaign"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/sms/broadcasts"
        },
        {
            "id": "action-create-sms-drip",
            "label": "Create SMS drip sequence",
            "keywords": ["create sms drip", "sms sequence", "text drip"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/sms/drip-sequences"
        },
        {
            "id": "action-create-automation",
            "label": "Create marketing automation",
            "keywords": ["create automation", "new automation", "marketing automation", "workflow"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/automations"
        },

        {
            "id": "action-connect-email",
            "label": "Connect email account",
            "keywords": ["connect email", "add email", "email sync", "gmail", "outlook", "imap"],
            "section": "Connect",
            "actionType": "hash",
            "actionValue": "#/connect-email/get-started"
        },
        {
            "id": "action-connect-calendar",
            "label": "Connect calendar",
            "keywords": [
                "connect calendar",
                "calendar sync",
                "google calendar",
                "outlook calendar"
            ],
            "section": "Connect",
            "actionType": "hash",
            "actionValue": "#/connect-calendar"
        },
        {
            "id": "action-connect-phone",
            "label": "Connect phone",
            "keywords": [
                "connect phone",
                "phone integration",
                "ringcentral",
                "dialpad",
                "click to call"
            ],
            "section": "Connect",
            "actionType": "hash",
            "actionValue": "#/connect-phone-integration/get-started"
        },
        {
            "id": "action-invite-teammate",
            "label": "Invite a teammate",
            "keywords": ["invite", "add user", "invite teammate", "new user", "add team member"],
            "section": "Admin",
            "actionType": "navigate",
            "actionValue": "/setup/user"
        },
        {
            "id": "action-keyboard-shortcuts",
            "label": "Keyboard shortcuts",
            "keywords": [
                "keyboard shortcuts",
                "shortcuts",
                "hotkeys",
                "key bindings",
                "keybindings"
            ],
            "section": "Utility",
            "actionType": "navigate",
            "actionValue": "/setup/index?shortcuts=true"
        },

        {
            "id": "action-ai-generate-report",
            "label": "Generate AI report",
            "keywords": [
                "generate report",
                "ai report",
                "create report",
                "build report",
                "report for",
                "report from prompt"
            ],
            "section": "AI",
            "actionType": "ai",
            "actionValue": "/reports/overview",
            "aiParam": "prompt"
        },
        {
            "id": "action-create-meeting",
            "label": "Create scheduler meeting",
            "keywords": [
                "create meeting",
                "new meeting",
                "scheduler meeting",
                "booking page",
                "schedule"
            ],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/sales/scheduler?create=true"
        },
        {
            "id": "action-create-broadcast",
            "label": "Create email broadcast",
            "keywords": [
                "create broadcast",
                "new broadcast",
                "email blast",
                "mass email",
                "email campaign"
            ],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/email/broadcasts?create=true"
        },
        {
            "id": "action-create-drip",
            "label": "Create drip sequence",
            "keywords": [
                "create drip",
                "new drip sequence",
                "email drip",
                "nurture sequence",
                "automation"
            ],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/email/drip-sequences?create=true"
        },
        {
            "id": "action-create-landing-page",
            "label": "Create landing page",
            "keywords": ["create landing page", "new landing page", "web page", "page builder"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/landing-pages?create=true"
        },
        {
            "id": "action-create-audience",
            "label": "Create audience",
            "keywords": ["create audience", "new audience", "segment", "email list", "targeting"],
            "section": "Create",
            "actionType": "navigate",
            "actionValue": "/marketing/audiences?create=true"
        },
        {
            "id": "action-ai-research-lead",
            "label": "Research a lead",
            "keywords": [
                "research lead",
                "lead research",
                "prospect research",
                "company research",
                "find info",
                "lead intel"
            ],
            "section": "AI",
            "actionType": "custom",
            "actionValue": "open-lead-researcher"
        },
        {
            "id": "action-ai-email-sequence",
            "label": "Write an email sequence",
            "keywords": [
                "write email sequence",
                "email sequence",
                "drip emails",
                "outreach sequence",
                "follow up sequence",
                "cold email"
            ],
            "section": "AI",
            "actionType": "custom",
            "actionValue": "open-email-sequence-writer"
        }
    ]
}
